let offsetTop = 0;
let appearEvt;
let disappearEvt;
const _appearDoms = [];

class AppearRegistry {
  static createEvent() {
    appearEvt = document.createEvent('HTMLEvents');
    disappearEvt = document.createEvent('HTMLEvents');
    appearEvt.initEvent('appear', false, true);
    disappearEvt.initEvent('disappear', false, true);
  }

  constructor(elements) {
    this.current = [];
    this.elements = elements;

    this.options = {
      container: window,
      wait: 100,
      x: 0,
      y: 0,
      cls: 'appear',
      once: false,
      onReset() {},
      onAppear() {},
      onDisappear() {},
    };
    this.container = null;
    this.appearWatchElements = null;

    this.initConfig.apply(this, arguments);
  }

  initConfig(opts) {
    this.extend(this.options, opts || (opts = {}));
    this.appearWatchElements = this.appearWatchElements || this.getElements();
    this.bindEvent();
  }

  extend(target, el) {
    for (const k in el) {
      if (el.hasOwnProperty(k)) {
        target[k] = el[k];
      }
    }
    return target;
  }

  inViewport(element, offset, type) {
    let { top, right, bottom, left } = element.getBoundingClientRect();

    left = offset.right > left && offset.left < right;
    top = offset.bottom > top - offsetTop && offset.top < bottom;
    return left && top;
  }

  getElements(type) {
    const { container } = this.options;
    let appearWatchElements;
    this.container = container;

    appearWatchElements = _appearDoms || [];
    appearWatchElements = [].slice.call(appearWatchElements, null);

    return appearWatchElements;
  }

  // check dom inview
  check(offset) {
    raf(() => {
      this.calculate();
    });
  }

  // calculate everyone dom inview
  calculate() {
    const { container } = this;
    const elements = this.getElements();
    const containerOffset = getOffset(window, {
      x: this.options.x,
      y: this.options.y,
    });
    const isOnce = this.options.once;
    const ev = arguments[0] || {};

    if (!container) {
      return;
    }

    if (elements && elements.length > 0) {
      [].forEach.call(elements, (ele, i) => {
        if (ele) {
          if (ele.isOnce && ele._hasAppear) {
            _appearDoms.splice(i, 1);
            elements.splice(i, 1);
            return;
          }
          this.checkEveryDom(ele, containerOffset, isOnce, appearEvt, disappearEvt, 'normal', i);
        }
      });
    }
  }

  checkEveryDom(ele, containerOffset, isOnce, cacheAppearEvt, cacheDisappearEvt, type, pos) {
    const eleOffset = getOffset(ele);
    const direction = this.getDirection(ele._eleOffset, eleOffset);
    const isInView = this.inViewport(ele, containerOffset, type);
    const appear = ele._appear;
    const { _hasAppear } = ele;
    const { _hasDisAppear } = ele;
    ele._eleOffset = eleOffset;

    cacheAppearEvt.direction = direction;
    cacheDisappearEvt.direction = direction;
    if (isInView && !appear) {
      if ((isOnce && !_hasAppear) || !isOnce) {
        ele.dispatchEvent(cacheAppearEvt);
        ele._hasAppear = true;
        ele._appear = true;
      }
    } else if (!isInView && appear) {
      if ((isOnce && !_hasDisAppear) || !isOnce) {
        ele.dispatchEvent(cacheDisappearEvt);
        ele._hasDisAppear = true;
        ele._appear = false;
      }
    }
  }

  // reset
  reset(opts) {
    this.initConfig(opts);
    this.appearWatchElements.forEach((ele) => {
      delete ele._hasAppear;
      delete ele._hasDisAppear;
      delete ele._appear;
    });
    return this;
  }
  bindEvent() {
    const handle = throttle(() => {
      this.check(arguments);
    }, this.options.wait);
    if (this.__handle) {
      this.container.removeEventListener('scroll', this.__handle, false, true);
      this.__handle = null;
    }
    this.__handle = handle;
    this.container.addEventListener('scroll', handle, false, true);
  }

  getDirection(beforeOffset, nowOffset) {
    let direction = 'none';
    const horizental = beforeOffset.left - nowOffset.left;
    const vertical = beforeOffset.top - nowOffset.top;
    if (vertical == 0) {
      if (horizental != 0) {
        direction = horizental > 0 ? 'left' : 'right';
      } else {
        direction = 'none';
      }
    }
    if (horizental == 0) {
      if (vertical != 0) {
        direction = vertical > 0 ? 'up' : 'down';
      } else {
        direction = 'none';
      }
    }
    return direction;
  }
}

let raf =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  function (c) {
    setTimeout(c, (1 / 60) * 1e3);
  };

function throttle(fn, wait) {
  let context;
  let args;
  let result;
  let timeout = null;
  let previous = 0;

  const later = () => {
    previous = Date.now();
    timeout = null;
    result = fn.apply(context, args);
  };
  return function () {
    const now = Date.now();
    const remaining = wait - (now - previous);
    context = this;
    args = arguments;

    if (remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = fn.apply(context, args);
    } else if (!timeout) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

export function config(opts) {
  if (opts.offsetTop && typeof opts.offsetTop === 'number') {
    offsetTop = opts.offsetTop;
  }
}

export function getOffset(el, param) {
  let l;
  let r;
  let b;
  let t;
  if (!el) {
    return;
  }
  if (!param) {
    param = { x: 0, y: 0 };
  }

  if (el != window) {
    el = el.getBoundingClientRect();
    l = el.left;
    t = el.top;
    r = el.right;
    b = el.bottom;
  } else {
    l = 0;
    t = 0;
    r = l + el.innerWidth;
    b = t + el.innerHeight;
  }

  return {
    left: l,
    top: t,
    right: r + param.x,
    bottom: b + param.y,
  };
}

// add element
export function pushElement(node) {
  if (_appearDoms.indexOf(node) === -1 && !node.appended) {
    const isOnce = Boolean(node.getAttribute('isonce')) || Boolean(node.getAttribute('data-once'));
    node.isOnce = isOnce;
    node.appended = true;
    _appearDoms.push(node);
    node._eleOffset = getOffset(node);
  }
}

export default AppearRegistry;
